import { Slot } from "@radix-ui/react-slot"
import { cn } from "@common/lib/utils"
import { type ComponentPropsWithoutRef, forwardRef } from "react"

export function GridTable({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">): React.ReactElement {
  return (
    <div
      role="table"
      className={cn("grid w-full text-[length:var(--font-size-body)]", className)}
      {...props}
    />
  )
}

export function GridTableHeader({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">): React.ReactElement {
  return (
    <div
      role="row"
      className={cn(
        "sticky top-[var(--filter-bar-height,2.5rem)] z-10 col-span-full grid grid-cols-subgrid bg-background shadow-[inset_0_-1px_0_hsl(var(--border))]",
        className,
      )}
      {...props}
    />
  )
}

export function GridTableHead({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">): React.ReactElement {
  return (
    <div
      role="columnheader"
      className={cn(
        "flex h-10 items-center whitespace-nowrap px-2 text-small-medium text-muted-foreground",
        className,
      )}
      {...props}
    />
  )
}

export const GridTableRow = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<"div"> & {
    asChild?: boolean
  }
>(function GridTableRow({ className, asChild = false, ...props }, ref) {
  const Comp = asChild ? Slot : "div"
  return (
    <Comp
      ref={ref}
      role="row"
      className={cn(
        "col-span-full grid grid-cols-subgrid border-b transition-colors hover:bg-muted/50 hover:no-underline",
        className,
      )}
      {...props}
    />
  )
})

export function GridTableCell({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">): React.ReactElement {
  return (
    <div
      role="cell"
      className={cn("flex items-center px-2 py-2", className)}
      {...props}
    />
  )
}
